import liff from "@line/liff";
import { getAssetUrl } from "@utils/getAssetUrl";

export const handleProductShareFriend = async (
	productName: string,
	productId: number,
	picture: string,
	trackingId: string,
) => {
	try {
		const shareUrl = `${process.env.REACT_APP_LIFF_URL}/ec/product/${productId}?td=${trackingId}`;

		const result = await liff.shareTargetPicker([
			{
				type: "text",
				text: `${productName} 真的很好看，想第一時間分享給你 ！​`,
			},
			{
				type: "flex",
				altText: `${productName} 真的很好看，想第一時間分享給你 ！`,
				contents: {
					type: "bubble",
					size: "giga",
					hero: {
						type: "image",
						url: picture,
						size: "full",
						aspectMode: "cover",
						aspectRatio: "1:1",
						action: { type: "uri", label: "立即尋找靈感", uri: shareUrl },
					},
				},
			},
			{
				type: "flex",
				altText: `${productName} 真的很好看，想第一時間分享給你 ！`,
				contents: {
					type: "bubble",
					size: "giga",
					hero: {
						type: "image",
						url: getAssetUrl("/images/ec-campaign/flex-message/btn.png"),
						size: "full",
						aspectMode: "cover",
						aspectRatio: "357:41",
						action: { type: "uri", label: "打開作品", uri: shareUrl },
					},
				},
			},
		]);

		if (result) {
			console.log("分享成功");
		}
	} catch (error) {
		console.error("分享時發生錯誤:", error);
	}
};
